import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from './api.service';
import { PauseDates, SubscriptionPause } from '../shared/types/subscription-pause.types';

/**
 * Membership pause endpoints (svc-order, CWS-1544). Data access only: each call returns the
 * refreshed pause block. `subscriptionId` is the subscriptions row id, not the Stripe id.
 */
@Injectable({ providedIn: 'root' })
export class SubscriptionPauseApiService {
  constructor(private readonly apiService: ApiService) {}

  /** Pauses today, or schedules a pause when `start` is a later date. */
  pause(subscriptionId: string, dates: PauseDates): Observable<SubscriptionPause> {
    return this.apiService
      .post<SubscriptionPause>(this.path(subscriptionId), dates)
      .pipe(map(response => response.data as SubscriptionPause));
  }

  cancelScheduled(subscriptionId: string): Observable<SubscriptionPause> {
    return this.apiService
      .delete<SubscriptionPause>(this.path(subscriptionId))
      .pipe(map(response => response.data as SubscriptionPause));
  }

  /** "Activate now": access resumes today, billing stays held until the banked days run out. */
  resume(subscriptionId: string): Observable<SubscriptionPause> {
    return this.apiService
      .post<SubscriptionPause>(`${this.path(subscriptionId)}/resume`, {})
      .pipe(map(response => response.data as SubscriptionPause));
  }

  private path(subscriptionId: string): string {
    return `order/subscription/${encodeURIComponent(subscriptionId)}/pause`;
  }
}
